import { useState } from "react";
import { HeartHandshake, Copy, Check } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionShell } from "./Reveal";

export default function Donations() {
  const { t } = useLang();
  const [done, setDone] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(t.donations.address);
      setDone(true);
      setTimeout(() => setDone(false), 2000);
    } catch {
      /* clipboard non disponibile */
    }
  };

  return (
    <SectionShell id="donazioni" testid="donations-section">
      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            {t.donations.title}
          </h2>
        </Reveal>

        <Reveal delay={0.12} className="mt-8">
          <div className="rounded-3xl border border-slate-200 bg-white p-8 sm:p-10 shadow-sm text-left">
            <div className="flex items-center gap-3 text-emerald-600">
              <HeartHandshake size={24} />
            </div>
            <p className="mt-4 text-lg sm:text-xl text-slate-800 leading-relaxed">{t.donations.p1}</p>
            <p className="mt-4 text-slate-600 leading-relaxed">{t.donations.p2}</p>

            <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4">
              <p className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                <span className="h-2.5 w-2.5 rounded-full bg-emerald-500" />
                {t.donations.network}
              </p>
              <p
                data-testid="donations-address"
                className="mt-3 break-all font-mono text-sm sm:text-base font-semibold text-slate-900"
              >
                {t.donations.address}
              </p>
              <button
                type="button"
                data-testid="donations-copy-btn"
                onClick={onCopy}
                className="mt-4 inline-flex items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-emerald-600"
              >
                {done ? <Check size={16} /> : <Copy size={16} />}
                {done ? t.donations.copied : t.donations.copy}
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
